import React, { useState } from 'react';

interface ConceptFormProps {
  enterprises: any[];
  onSubmit: (formData: any) => Promise<void>;
  onCancel: () => void;
  initialData?: any;
}

const ConceptForm: React.FC<ConceptFormProps> = ({ enterprises, onSubmit, onCancel, initialData }) => {
  const [formData, setFormData] = useState({
    name: initialData?.name || '',
    enterpriseId: initialData?.enterpriseId || '',
    description: initialData?.description || '',
    brandType: initialData?.brandType || 'fast_casual',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.enterpriseId) {
      alert('Concept name and enterprise are required');
      return;
    }

    setIsSubmitting(true);
    try {
      await onSubmit({
        ...formData,
        type: 'concept'
      });
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (field: string, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label className="label-modern">Concept Name *</label>
        <input
          type="text"
          className="input-modern"
          placeholder="Enter concept name"
          value={formData.name}
          onChange={(e) => handleChange('name', e.target.value)}
          required
        />
      </div>
      <div className="form-group">
        <label className="label-modern">Enterprise *</label>
        <select
          className="input-modern"
          value={formData.enterpriseId}
          onChange={(e) => handleChange('enterpriseId', e.target.value)}
          required
        >
          <option value="">Select Enterprise</option>
          {enterprises.map(ent => (
            <option key={ent.enterpriseId} value={ent.enterpriseId}>{ent.name}</option>
          ))}
        </select>
      </div>
      <div className="form-group">
        <label className="label-modern">Description</label>
        <textarea
          className="input-modern"
          placeholder="Concept description"
          rows={3}
          value={formData.description}
          onChange={(e) => handleChange('description', e.target.value)}
        />
      </div>
      <div className="form-group">
        <label className="label-modern">Brand Type</label>
        <select
          className="input-modern"
          value={formData.brandType}
          onChange={(e) => handleChange('brandType', e.target.value)}
        >
          <option value="fast_casual">Fast Casual</option>
          <option value="fine_dining">Fine Dining</option>
          <option value="quick_service">Quick Service</option>
          <option value="coffee_shop">Coffee Shop</option>
          <option value="other">Other</option>
        </select>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn-modern btn-modern-secondary"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="btn-modern btn-modern-primary"
          disabled={isSubmitting}
        >
          {isSubmitting ? (initialData ? 'Updating...' : 'Creating...') : (initialData ? 'Update Concept' : 'Create Concept')}
        </button>
      </div>
    </form>
  );
};

export default ConceptForm;